import classes from "./login-content.module.scss";

import React from "react";

import { usePageLoginState } from "../../contexts";
import { LoginContentForm } from "./form";
import { LoginContentStatus } from "./status";

export const LoginContent = () => {
  const { hasEmail } = usePageLoginState();

  return <div className={classes["content"]}>{!hasEmail ? <LoginContentForm /> : <LoginContentStatus />}</div>;
};
